import Myapplicationview from "../../../jsx/components/Dashboard/MyApplications/myapplicationview";

const MyApplicationViewWrapper = () => {
  return <Myapplicationview />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.customer];
export default constore(MyApplicationViewWrapper);
